<template>
  <div id="mark-modal-shop-select">
    <template v-if="isViewComponent()">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-header">
              <h3 class="card-title">Дополнительные параметры</h3>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <label class="form-label">Текст накладываемый на картинку поста:</label>
                  <div class="fallback">
                    <input type="text" class="form-control no-outline" v-model="imageOverlayText" @keyup="onImageOverlayText"/>
                  </div>
                </div>
                <div class="mt-1 col-md-12">
                  <label class="form-check form-check-inline">
                    <input class="form-check-input no-outline" type="checkbox" @change="onImageOverlayTextStatus" v-model="imageOverlayTextStatus">
                    <span class="form-check-label">Применить наложение</span>
                  </label>
                </div>
                <div class="mt-1 col-md-12">
                  <button class="btn btn-twitter w-100 mb-3" :class="{'disabled': isPreviewPending() || !hasViewPreview()}" @click="onPreviewHandle">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-photo">
                      <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                      <path d="M15 8h.01" />
                      <path d="M3 6a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v12a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3v-12z" />
                      <path d="M3 16l5 -5c.928 -.893 2.072 -.893 3 0l5 5" />
                      <path d="M14 14l1 -1c.928 -.893 2.072 -.893 3 0l3 3" />
                    </svg>
                    <span class="spinner-border spinner-border-sm me-2" v-show="isPreviewPending()"></span>
                    Предпросмотр
                  </button>
                </div>
                <div class="mt-1 col-md-12" v-if="hasPreviewImage()">
                  <template v-if="isPreviewPending()">
                    <span class="spinner-border spinner-border-sm me-2"></span>
                  </template>
                  <template v-else>
                    <img :src="getPreviewImage()" alt="">
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="page-body">
        <div class="container-xl">
          <div class="row">
            <div class="mb-3">
              <div class="loader-item">
                <div class="spinner-border spinner-border-sm me-2"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import "./css/style.css"
import {defineComponent, onMounted, onUnmounted, reactive, ref, watch} from "vue"
import Api from "./services/Api"

export default defineComponent({
  name: "AdditionalSettings",
  components: {},
  props: {
    payload: {
      type: Object,
      required: true
    },
  },
  setup(props, {emit, expose}) {
    let viewComponent = ref(false)

    let imageOverlayText = ref("")
    let imageOverlayTextStatus = ref(true)

    let previewPending = ref(false)
    let previewImage = ref("")

    const payload = reactive({
      post_id: null,
      shop_host: null,
    })

    onMounted(() => {
      updatePayload(props.payload)
      
      let shopHost = getShopHostPayload()

      Api.getImageOverlay(shopHost).then((resp) => {
        imageOverlayText.value = resp["text"]

        pushParent(imageOverlayText.value, imageOverlayTextStatus.value)
        enableViewComponent()
      })
    })

    onUnmounted(() => {
      disableViewComponent()
    })

    watch(() => props.payload, (newValues) => {
      updatePayload(newValues)
    })

    function getShopHostPayload() {
      return payload.shop_host
    }

    function enableViewComponent() {
      viewComponent.value = true
    }

    function disableViewComponent() {
      viewComponent.value = false
    }

    function updatePayload(query) {
      payload.post_id = query.post_id
      payload.shop_host = query.shop_host
    }

    function isViewComponent() {
      return viewComponent.value === true
    }

    function pushParent(text, status) {
      emit("changeVal", getResult(text, status))
    }

    function getResult(text, status) {
      return {
        text: text,
        status: status,
      }
    }

    function onImageOverlayTextStatus(e) {
      imageOverlayTextStatus.value = e.target.checked
      pushParent(imageOverlayText.value, imageOverlayTextStatus.value)
    }

    function onImageOverlayText(e) {
      imageOverlayText.value = e.target.value
      pushParent(imageOverlayText.value, imageOverlayTextStatus.value)
    }

    async function startRequest(postId, text, status) {
      let state = status === true ? 1 : 0

      return Api.setImageOverlay(postId, text, state)
    }

    expose({ startRequest })

    function startPreviewPending() {
      previewPending.value = true
    }

    function stopPreviewPending() {
      previewPending.value = false
    }

    function isPreviewPending() {
      return previewPending.value === true
    }

    function getPostIdPayload() {
      return payload.post_id
    }

    function onPreviewHandle() {
      startPreviewPending()

      let state = imageOverlayTextStatus.value === true ? 1 : 0

      return Api.previewImageOverlay(getPostIdPayload(), imageOverlayText.value, state).then((resp) => {
        previewImage.value = resp["item"]["link"]
      }).finally(() => {
        stopPreviewPending()
      })
    }

    function getPreviewImage() {
      return previewImage.value
    }

    function hasPreviewImage() {
      return previewImage.value !== ""
    }

    function hasViewPreview() {
      return imageOverlayText.value !== "" && imageOverlayTextStatus.value === true
    }

    return {
      isViewComponent,
      imageOverlayText,
      imageOverlayTextStatus,
      onImageOverlayTextStatus,
      onImageOverlayText,
      isPreviewPending,
      onPreviewHandle,
      getPreviewImage,
      hasPreviewImage,
      hasViewPreview,
    }
  }
})
</script>
